import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1195100e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Bryan White")
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  href: "https://github.com/bryanchriswhite/",
  target: "_blank"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "profile-picture",
  src: "/assets/bryan_white.jpg",
  alt: "profile picture"
}, null, -1))
const _hoisted_5 = {
  href: "https://www.linkedin.com/in/bryanchriswhite/",
  target: "_blank"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Github Activity", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Technology Timeline", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Language Experience", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Work Experience", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_codersrank_activity = _resolveComponent("codersrank-activity")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_codersrank_timeline = _resolveComponent("codersrank-timeline")!
  const _component_codersrank_skills_chart = _resolveComponent("codersrank-skills-chart")!
  const _component_codersrank_work_experience = _resolveComponent("codersrank-work-experience")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { id: "links-col" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", _hoisted_3, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.logoGithub,
                            class: "large-icon"
                          }, null, 8, ["icon"])
                        ]),
                        _hoisted_4,
                        _createElementVNode("a", _hoisted_5, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.logoLinkedin,
                            class: "large-icon"
                          }, null, 8, ["icon"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      "size-md": "6",
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, { color: "dark" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_codersrank_activity, {
                                  username: "bryanchriswhite",
                                  labels: "true",
                                  legend: "true",
                                  tooltip: "true",
                                  step: "3",
                                  weeks: "26",
                                  branding: "false"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card, { color: "dark" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_codersrank_timeline, {
                                  username: "bryanchriswhite",
                                  type: "technologies",
                                  branding: "false"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      "size-md": "6",
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, { color: "dark" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_codersrank_skills_chart, {
                                  username: "bryanchriswhite",
                                  legend: "true",
                                  tooltip: "true",
                                  branding: "false",
                                  skills: "HTML,Css,C,Ruby,Python,Go,TypeScript,Shell,Dart,Vue,JavaScript",
                                  "show-other-skills": "true"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, { color: "dark" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_codersrank_work_experience, {
                                  username: "bryanchriswhite",
                                  logos: "true",
                                  grid: "true",
                                  branding: "false",
                                  style: _normalizeStyle({'--grid-columns': _ctx.workExperienceColumns})
                                }, null, 8, ["style"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}